import {makePostCheckoutPayment} from 'main/factories/usecases';
import type {PostCheckoutPaymentModel, PostCheckoutPaymentParams} from 'domain/usecases';

export const postCheckoutPayment = async (
	params: Omit<PostCheckoutPaymentParams, 'signal'>,
): Promise<PostCheckoutPaymentModel> => {
	const response = await makePostCheckoutPayment().post(params);
	return response;
};
